<template>
    <div class="page-header align-items-start min-vh-100">
        <span class="mask bg-white"></span>
  
        <div class="container">
            <div class="row">
            <div class="notifications">
                <material-alert v-if="error" color="danger" icon="ni ni-like-2 ni-lg" dismissible>
                {{ error }}
                </material-alert>
            </div>
            <div class="col-lg-4 col-md-8 col-12 mx-auto">
                <div class="d-flex justify-content-center mt-5">
                <img src="../assets/img/logo-ordering.png" class="avatar avatar-md mb-3 border-radius-lg" alt="user1" />
                </div>
                <div class="card-body">
                    <div class="mt-6 mb-3">
                        <form role="form" class="text-start">
                            <div class="text-center pb-3">
                            Enter your birthday in DDMM* format
                            </div>
                            <div id="otp" class="inputs d-flex flex-row justify-content-center mt-6" style="align-items: center;">
                            <span style="margin-top: 10px;" class="material-icons me-3 icon-color-green md-30">lock_open</span>
                                <v-otp-input
                                    ref="inputEnterPasscode"
                                    input-classes="otp-input"
                                    separator=""
                                    :num-inputs="4"
                                    :should-auto-focus="true"
                                    :is-input-num="true"
                                    :conditionalClass="['one', 'two', 'three', 'four']"
                                    :placeholder="['', '', '', '']"
                                    @on-complete="handleOnCompleteAlreadyPasscode"
                                    v-model="form.passcode"
                                />
                            </div>
                        </form>
                        <div style="display: inline-flex;gap: 10px;" class="mt-5">
                            <div class="text-center">
                                <a style="font-size: 14px;" class="">Forget your birthday ?</a>
                            </div>
                            <div class="text-center">
                                <a style="font-size: 14px;" @click="gotoEnterOneTimePasscode()" class="text-decoration-underline text-info">Get one-time passcode</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
        <div v-if="isLoginNormal" style="position: absolute;bottom: 0;left: 30%;transform: translateX(-20%);">
            <div class="mb-1">
                <a class="" style="margin-left: 25px;">*DD: day of your birthday</a>
            </div>
            <div class="mb-4">
                <a class="" style="margin-left: 25px;">MM: month of your birthday</a>
            </div>
        </div>
        <div class="position-fixed top-1 end-1 z-index-2">
            <material-snackbar v-if="snackbar === 'danger'" title="" date="" description="Email or password is incorrect"
            :icon="{ component: 'campaign', color: 'white' }" color="danger" :close-handler="closeSnackbar" />
        </div>
    </div>
</template>
  
<script>
    import MaterialAlert from "@/components/MaterialAlert.vue";
    import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
    import VOtpInput from "vue3-otp-input";
    import router from "@/router";
  
    export default {
        name: "reset-to-initial-passcode",
        components: {
            MaterialAlert,
            MaterialSnackbar,
            VOtpInput
        },
        data() {
            return {
                form: {
                    phone_code: '+65',
                    phone_number: this.$route.query.phone,
                    passcode: ''
                },
                snackbar: null,
                error: '',
                merchantCode: "",
                branchCode: ""
            };
        },
        mounted() {
            const merchantCode = localStorage.getItem("MERCHANT_CODE", "");
            this.merchantCode = merchantCode ? `/${merchantCode}` : "";
            const branchCode = localStorage.getItem("BRANCH_CODE", "");
            this.branchCode = branchCode ? `/${branchCode}` : "";
        },
        methods: {
            login: function () {
                if(this.form.passcode == "") {
                    this.snackbar = 'danger'
                    this.message = "Passcode can not blank."
                    this.setTimeOutNotification();
                    return;
                }
                this.successful = false;
                this.loading = true;
                this.$store.dispatch("auth/loginByPhoneAndPasscode", this.form).then(
                    (data) => {
                    if (data != undefined && !data.result.isSuccess) {
                        this.snackbar = 'danger'
                        this.message = data.result.message
                        this.setTimeOutNotification();
                    } else {
                        router.push(this.merchantCode + this.branchCode+"/order?memorize=1");
                    }
                    },
                    (error) => {
                    console.log('ERROR' + error)
                    }
                );
            },
            closeSnackbar() {
                this.snackbar = null;
            },
            gotoEnterOneTimePasscode() {
                this.$store.dispatch("auth/sendOneTimePasscode", this.form).then(
                    (data) => {
                        if (data != undefined && !data.result.isSuccess) {
                            this.snackbar = 'danger'
                            this.message = data.result.message
                            this.setTimeOutNotification();
                        } else {
                            this.snackbar = 'success'
                            this.message = "Sent successfully!"
                            this.setTimeOutNotification();
                            setTimeout(() => {
                                this.$router.push(this.merchantCode + this.branchCode + "/enter-one-time-passcode?phone="+this.form.phone_number);
                            }, 1000);
                        }
                    },
                    (error) => {
                        console.log('ERROR' + error)
                    }
                );
            },
            handleOnCompleteAlreadyPasscode: function (value) {
                this.form.passcode = value;
                this.login();
            },
            setTimeOutNotification() {
                setTimeout(() => {
                    this.snackbar = null;
                }, 3000);
            },
        },
    };
  </script>
<style>
    .otp-input {
        width: 40px;
        height: 40px;
        padding: 5px;
        margin: 0 10px;
        font-size: 20px;
        border: none;
        border-bottom: 2px solid green;
        text-align: center;
        border-radius: 0px !important;
        background: none;
    }
    
    .form-control:disabled,
    .form-control[readonly] {
        padding: 2px !important;
    }
    
    .text-green {
        color: #f9dd4b;
    }
    
    .otp-input:focus {
        outline: none !important;
    }
    
    .otp-input::-webkit-inner-spin-button,
    .otp-input::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    
    input::placeholder {
        font-size: 15px;
        text-align: center;
        font-weight: 600;
    }
</style>
  